import { OfficeBase } from "@core/base/office-base";
import { IOfficeHost } from "@core/shared/office-hosts/office-host.types";
import { OneNoteHost } from "@core/shared/office-hosts/onenote-host";
import { ExcelHost } from "@core/shared/office-hosts/excel-host";
import { PowerPointHost } from "@core/shared/office-hosts/power-point-host";
import { OutlookHost } from "@core/shared/office-hosts/outlook-host";
import { WordHost } from "@core/shared/office-hosts/word-hosts";

export class OfficeService extends OfficeBase implements OfficeBase {
    constructor() {
        super()
    }

    public getHost(): IOfficeHost {
        if (this.currentHost) return this.currentHost;

        let host;
        switch (this.hostType) {
            case Office.HostType.OneNote:
                host = new OneNoteHost();
                break;
            case Office.HostType.Excel:
                host = new ExcelHost();
                break;
            case Office.HostType.PowerPoint:
                host = new PowerPointHost();
                break;
            case Office.HostType.Outlook:
                host = new OutlookHost();
                break;
            case Office.HostType.Word:
                host = new WordHost();
                break;

            default:
                throw new Error("Host " + Office.HostType[this.hostType!] + " is not implemented.");
        }

        this.currentHost = host;
        return this.currentHost;
    }
}
